import React from 'react';
import IssueRegistrationCode from "../controls/IssueRegistrationCode";

export default function CodesPage() {
    return (
        <IssueRegistrationCode />
    );
}
